import { useEffect } from "react";
import { ContactForm } from "../components/Forms";
import { Typography } from "antd";
import { title } from "../styles";
const { Title } = Typography;
export default function Contact(args) {
  useEffect(() => {
    args.setCurrent("contact");
    document.title = "Bize Ulaş | Zenofy";
  }, [args]);
  return (
    <div
      style={{
        marginTop: "6rem",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
      }}
    >
      <Title style={{ ...title(args.device), marginBottom: "3rem" }}>
        Bize Ulaş
      </Title>
      <ContactForm device={args.device} />
    </div>
  );
}
